// EventForm.jsx
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createEvent } from '../../Redux/Actions/actions';
import styles from './EventForm.module.css';

const EventForm = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    titulo: '',
    descripcion: '',
    fecha: '',
    horaInicio: '',
    horaFin: '',
  });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(createEvent(form));
    setForm({ titulo: '', descripcion: '', fecha: '', horaInicio: '', horaFin: '' });
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <h2 className={styles.title}>Crear Evento</h2>
      <label>
        Título
        <input name="titulo" value={form.titulo} onChange={handleChange} required />
      </label>
      <label>
        Descripción
        <input name="descripcion" value={form.descripcion} onChange={handleChange} required />
      </label>
      <label>
        Fecha
        <input type="date" name="fecha" value={form.fecha} onChange={handleChange} required />
      </label>
      <label>
        Hora Inicio
        <input type="time" name="horaInicio" value={form.horaInicio} onChange={handleChange} required />
      </label>
      <label>
        Hora Fin
        <input type="time" name="horaFin" value={form.horaFin} onChange={handleChange} required />
      </label>
      <button className={styles.button} type="submit">Crear</button>
    </form>
  );
};

export default EventForm;